<template>
  <!-- Contenedor centrado en la pantalla con fondo transparente -->
  <div class="d-flex justify-content-center align-items-center min-vh-100" style="background: transparent;">
    <!-- Contenedor del formulario -->
    <div class="w-50">
      <div class="card border-0" style="background: transparent;">
        <div class="card-body">
          <form @submit.prevent="submitForm">
            <div v-for="(config, key) in formFields" :key="key" class="mb-3">
              <!-- Para el campo "colaborador" usamos el AutocompleteSelect -->
              <div v-if="key === 'colaborador'">
                <label :for="key" class="form-label d-block">{{ config.label }}</label>
                <AutocompleteSelect v-model="form.colaborador" :options="config.options"
                  :placeholder="config.placeholder || 'Selecciona un colaborador'" />
              </div>
              <!-- Bloque para campos de tipo checkbox -->
              <div v-else-if="config.type === 'checkbox'" class="form-check">
                <input type="checkbox" :id="key" v-model="form[key]" class="form-check-input" />
                <label :for="key" class="form-check-label">{{ config.label }}</label>
              </div>
              <!-- Bloque para campos numéricos -->
              <div v-else-if="config.type === 'number'">
                <label :for="key" class="form-label d-block">{{ config.label }}</label>
                <input type="number" :id="key" v-model.number="form[key]" :placeholder="config.placeholder"
                  class="form-control" :maxlength="config.maxlength" :max="config.max" :style="config.inputStyle" />
              </div>
              <!-- Bloque para otros select -->
              <div v-else-if="config.type === 'select'">
                <label :for="key" class="form-label d-block">{{ config.label }}</label>
                <select :id="key" v-model="form[key]" class="custom-select-box" :style="config.inputStyle">
                  <option v-for="option in config.options" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
              <!-- Bloque para campos tipo textarea -->
              <div v-else-if="config.type === 'textarea'">
                <label :for="key" class="form-label d-block">{{ config.label }}</label>
                <textarea :id="key" v-model="form[key]" :placeholder="config.placeholder" class="form-control"
                  :style="config.inputStyle"></textarea>
              </div>
              <!-- Bloque para inputs de texto u otros -->
              <div v-else>
                <label :for="key" class="form-label d-block">{{ config.label }}</label>
                <input :type="config.type" :id="key" v-model="form[key]" :placeholder="config.placeholder"
                  class="form-control" :maxlength="config.maxlength" :max="config.max" :style="config.inputStyle" />
              </div>
              <!-- Mensaje de error con transición -->
              <transition name="fade">
                <small class="text-danger" v-if="errors[key]">{{ errors[key] }}</small>
              </transition>
            </div>
            <button type="submit" class="btn btn-primary w-100 py-2">
              Guardar
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AutocompleteSelect from "./inputs/AutocompleteSelect.vue";

export default {
  name: "ProyectoComunidad",
  components: { AutocompleteSelect },
  data() {
    return {
      // Valores predeterminados para el formulario.
      form: {
        id: null,
        colaborador: "", // ID del colaborador seleccionado
        comercial: "",   // ID del usuario (obtenido de la URL)
        observaciones: "",
        rsocial: "",
        direccion_linea1: "",
        direccion_linea2: "",
        cif: "",
        anyo_construccion: 0,
        anyo_rehabilitacion: 0,
        tipo_rehabilitacion: "ninguna", // Por defecto "ninguna"
        numero_viviendas: 0,
        numero_locales: 0,
        numero_garajes: 0,
        metros_vivienda: 0,
        metros_locales: 0,
        metros_garaje: 0,
        numero_portales: 0,
        alturas_sobre_rasante: 0,
        alturas_ajo_rasante: 0,
        tipo_calefaccion: "NO TIENE", // Por defecto "NO TIENE"
        portero: "No",               // Por defecto "No" (desplegable)
        numero_piscinas: 0,
        urbanizacion: "No",          // Por defecto "No" (desplegable)
        numero_ascensores: 0,
        vencimiento: ""
      },
      authToken: null,
      errors: {},
      // Definición de campos (ejemplo)
      formFields: {
        colaborador: {
          label: "Colaborador",
          type: "select",
          placeholder: "Selecciona un colaborador",
          options: [], // Se llenará dinámicamente con la API
          inputStyle: "max-width: 200px;"
        },
        // Ejemplo de otros campos:
        rsocial: {
          label: "Razón Social",
          type: "text",
          placeholder: "Razón Social",
          maxlength: 100,
          inputStyle: "max-width: 300px;"
        },
        direccion_linea1: {
          label: "Dirección (línea 1)",
          type: "text",
          placeholder: "Dirección (línea 1)",
          maxlength: 100,
          inputStyle: "max-width: 300px;"
        },
        direccion_linea2: {
          label: "Dirección (línea 2)",
          type: "text",
          placeholder: "Dirección (línea 2)",
          maxlength: 100,
          inputStyle: "max-width: 300px;"
        },
        cif: {
          label: "CIF/NIF",
          type: "text",
          placeholder: "CIF/NIF",
          maxlength: 10,
          inputStyle: "max-width: 150px;"
        },
        anyo_construccion: {
          label: "Año de construcción",
          type: "number",
          placeholder: "Año de construcción",
          maxlength: 4,
          max: 9999,
          inputStyle: "max-width: 100px;"
        },
        anyo_rehabilitacion: {
          label: "Año de rehabilitación",
          type: "number",
          placeholder: "Año de rehabilitación",
          maxlength: 4,
          max: 9999,
          inputStyle: "max-width: 100px;"
        },
        tipo_rehabilitacion: {
          label: "Tipo de rehabilitación",
          type: "select",
          options: [
            { value: "total", label: "Total" },
            { value: "parcial", label: "Parcial" },
            { value: "ninguna", label: "Ninguna" }
          ],
          inputStyle: "max-width: 200px;"
        },
        numero_viviendas: {
          label: "Número de viviendas",
          type: "number",
          placeholder: "Número de viviendas",
          inputStyle: "max-width: 100px;"
        },
        numero_locales: {
          label: "Número de locales",
          type: "number",
          placeholder: "Número de locales",
          inputStyle: "max-width: 100px;"
        },
        numero_garajes: {
          label: "Número de garajes",
          type: "number",
          placeholder: "Número de garajes",
          inputStyle: "max-width: 100px;"
        },
        metros_vivienda: {
          label: "Metros de vivienda",
          type: "number",
          placeholder: "Metros de vivienda",
          inputStyle: "max-width: 150px;"
        },
        metros_locales: {
          label: "Metros de locales",
          type: "number",
          placeholder: "Metros de locales",
          inputStyle: "max-width: 150px;"
        },
        metros_garaje: {
          label: "Metros de garaje",
          type: "number",
          placeholder: "Metros de garaje",
          inputStyle: "max-width: 150px;"
        },
        numero_portales: {
          label: "Número de portales",
          type: "number",
          placeholder: "Número de portales",
          inputStyle: "max-width: 100px;"
        },
        alturas_sobre_rasante: {
          label: "Alturas sobre rasante",
          type: "number",
          placeholder: "Alturas sobre rasante",
          inputStyle: "max-width: 100px;"
        },
        alturas_ajo_rasante: {
          label: "Alturas bajo rasante",
          type: "number",
          placeholder: "Alturas bajo rasante",
          inputStyle: "max-width: 100px;"
        },
        tipo_calefaccion: {
          label: "Tipo de calefacción",
          type: "select",
          options: [
            { value: "INDIVIDUAL", label: "INDIVIDUAL" },
            { value: "CENTRAL", label: "CENTRAL" },
            { value: "NO TIENE", label: "NO TIENE" }
          ],
          inputStyle: "max-width: 200px;"
        },
        portero: {
          label: "Tiene portero",
          type: "select",
          options: [
            { value: "Si", label: "Si" },
            { value: "No", label: "No" }
          ],
          inputStyle: "max-width: 150px;"
        },
        numero_piscinas: {
          label: "Número de piscinas",
          type: "number",
          placeholder: "Número de piscinas",
          inputStyle: "max-width: 100px;"
        },
        urbanizacion: {
          label: "Urbanización",
          type: "select",
          options: [
            { value: "Si", label: "Si" },
            { value: "No", label: "No" }
          ],
          inputStyle: "max-width: 150px;"
        },
        numero_ascensores: {
          label: "Número de ascensores",
          type: "number",
          placeholder: "Número de ascensores",
          inputStyle: "max-width: 100px;"
        },
        vencimiento: {
          label: "Vencimiento del seguro actual",
          type: "date",
          placeholder: "dd/mm/yyyy",
          inputStyle: "max-width: 200px;"
        },
        observaciones: {
          label: "Observaciones",
          type: "textarea",
          placeholder: "Observaciones",
          inputStyle: "max-width: 100%; min-height: 100px;"
        }

      }
    };
  },
  methods: {
    async submitForm() {
      try {
        // Convertir campos "portero" y "urbanizacion" de "Si"/"No" a booleano
        this.form.portero = this.form.portero === "Si";
        this.form.urbanizacion = this.form.urbanizacion === "Si";

        // Construir la URL y el endpoint de la API
        const API_URL = import.meta.env.VITE_DJANGO_URL;
        const endpoint = `/api/crear-proyecto-comunidad/`;

        // Construir la cadena del comando cURL usando el objeto "form"
        const curlCommand = `curl -X POST "${API_URL}${endpoint}" -H "Content-Type: application/json" -d '${JSON.stringify(this.form)}'`;
        console.log("CURL command:", curlCommand);

        // Realizar la petición POST
        const response = await axios.post(`${API_URL}${endpoint}`, this.form);
        console.log("Proyecto creado", response.data);
        this.form.id = response.data.id;
        
        // Redirigir a la URL de edición usando el ID del proyecto creado
        // Usamos window.top.location.href para salir del iframe y redirigir la ventana principal
        window.top.location.href = `https://portal.jlaasociados.net/proyectocomunidad/editar/${this.form.id}`;
        
      } catch (error) {
        console.error("Error al crear el proyecto", error.response.data);
        this.errors = error.response.data;
      }
    },
    async fetchCollaboradores() {
      try {
        const API_URL = import.meta.env.VITE_DJANGO_URL;
        const endpoint = "/api/colaboradores/?page_size=1000";
        const apiToken = this.$auth?.apiToken;
        const headers = apiToken ? { Authorization: `Token ${apiToken}` } : {};
        const response = await axios.get(`${API_URL}${endpoint}`, { headers });
        let colaboradores = Array.isArray(response.data)
          ? response.data
          : response.data.results;
        this.formFields.colaborador.options = colaboradores.map((colaborador) => ({
          value: colaborador.id,
          label: `${colaborador.codinterno} -- ${colaborador.rsocial}`
        }));
      } catch (error) {
        console.error("Error fetching colaboradores:", error);
      }
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get("user_id");
    if (userId) {
      this.form.comercial = userId;
    } else {
      console.warn("No se encontró el parámetro user_id en la URL.");
    }
    this.authToken = params.get("auth_token");
    this.fetchCollaboradores();
  }
};
</script>

<style scoped>
/* Transiciones para mensajes de error */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Estilos personalizados para los select box (para los que siguen usando <select>) */
.custom-select-box {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg width='4' height='5' viewBox='0 0 4 5' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M2 0L0 2H4L2 0Z' fill='%236c757d'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 8px 10px;
}
</style>